import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import {
  ManagementEventModel,
  ManagementIsfManualStateModel,
  ManagementIsfModel,
  ManagementIsfSearchModel,
  ManagementIsfShortModel,
} from '@data-layer/models/management';
import { BondModel, PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class IsfManagementRepository {
  constructor(private apiService: ApiService) {}

  public get(id: ManagementIsfModel['id'], isShowLoader: boolean = true): Observable<ManagementIsfModel> {
    return this.apiService.get<ManagementIsfModel>(`${environment.url.isfManagement}${id}`, null, {
      isShowLoader,
    });
  }

  public getByRefNumber(referenceNumber: string): Observable<ManagementIsfModel> {
    return this.apiService.get<ManagementIsfModel>(`${environment.url.isfManagement}details?referenceNumber=${referenceNumber}`);
  }

  public setState(id: number, state: ManagementIsfManualStateModel): Observable<never> {
    return this.apiService.put(`${environment.url.isfManagement}${id}/state`, state);
  }

  public search(params: ManagementIsfSearchModel, isShowLoader: boolean = true): Observable<PaginatedResultModel<ManagementIsfShortModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementIsfShortModel>>(
      `${environment.url.isfManagement}`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public updateBond(id: number, bond: BondModel): Observable<BondModel> {
    return this.apiService.put<BondModel>(`${environment.url.isfManagement}${id}/bond`, bond);
  }

  public getEvents(
    id: number,
    params: PaginationSearchModel,
    isShowLoader: boolean = false,
  ): Observable<PaginatedResultModel<ManagementEventModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementEventModel>>(
      `${environment.url.isfManagement}${id}/events`,
      { params },
      { isShowLoader },
    );
  }

  public resetProviderEvent(isfId: number, eventId: number): Observable<void> {
    return this.apiService.put<void>(`${environment.url.isfManagement}${isfId}/last-event-id`, eventId);
  }
}
